import { MarketDisplayItemInstrument as MainModel } from "@/models/marketData";
import { createBaseStore } from "./baseStore";

export const useInstrumentStore = createBaseStore<MainModel, {}>(
  "instruments",
  "instrumentSeq"
);
